import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import { AutomaticReportJob } from "@/models/AutomaticReports/AutomaticReportJob";
import QueryableInterface from "@/interfaces/QueryableInterface";
import Base from "./Base";

const HTTP_REQUEST_ACTION = "http/request";

export const JOBS_PER_PAGE = 10;

export enum AutomaticReportJobsTags {
  INDEX = "get_automatic_report_jobs",
  REPLAY = "replay_automatic_report_jobs",
}

@Component
export default class AutomaticReportJobMixin extends Base {
  // A per-report `tag` keeps each open accordion's meta/links isolated in the
  // shared `http/status` store (several report rows can be expanded at once).
  automaticReportJobsTag(automaticReportId: string | number): string {
    return `${AutomaticReportJobsTags.INDEX}_${automaticReportId}`;
  }

  indexAutomaticReportJobs(
    profileSlug: string,
    automaticReportId: string | number,
    page = 1,
    tag: string = this.automaticReportJobsTag(automaticReportId)
  ): Promise<AutomaticReportJob[]> {
    const params: QueryableInterface = {
      page: { number: page, size: JOBS_PER_PAGE },
    };
    const queryString = this.paramsToQueryString({
      automatic_report_id: automaticReportId,
      ...params,
    });
    const url = `${API_ENDPOINT}/${profileSlug}/automatic_report_jobs.json?${queryString}`;

    return this.$store.dispatch(HTTP_REQUEST_ACTION, {
      tag,
      url,
      method: "GET",
    });
  }

  replayAutomaticReportJob(
    profileSlug: string,
    automaticReportJobId: string | number
  ): Promise<unknown> {
    const url = `${API_ENDPOINT}/${profileSlug}/automatic_report_jobs/${automaticReportJobId}/replay.json`;

    return this.$store.dispatch(HTTP_REQUEST_ACTION, {
      tag: AutomaticReportJobsTags.REPLAY,
      url,
      method: "PATCH",
    });
  }
}
